import React, { useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/system";
import { Box, CircularProgress, TextField, Typography } from "@mui/material";
import { useState } from "react";
import RemoveIcon from "@mui/icons-material/Delete";
import heic2any from "heic2any";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePrize } from "../../../redux/slices/adminSlice";
import Parse from "parse";
import { setNotification } from "../../../redux/slices/notificationsSlice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditGiftModal = ({ open, onClose, giftToEdit, onSuccessEditGift }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const inputRefEdit = useRef(null);

  const [name, setName] = useState();
  const [stock, setStock] = useState();
  const [pointsNeeded, setPointsNeeded] = useState();
  //   const [photo, setPhoto] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const [imageUrl, setImageUrl] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);

  const updatePrizeLoading = useSelector(
    (state) => state.admin.updatePrizeLoading
  );
  const updatePrizeError = useSelector((state) => state.admin.updatePrizeError);

  const onChangeNameInput = (event) => {
    setName(event.target.value);
  };
  const onChangeStockInput = (event) => {
    setStock(event.target.value);
  };
  const onChangePointsNeededInput = (event) => {
    setPointsNeeded(event.target.value);
  };
  const onUpdateGift = async () => {
    const isFile = selectedFile.__type === "File";
    const imgFile = !isFile
      ? new Parse.File(selectedFile.name, selectedFile)
      : selectedFile;
    !isFile && (await imgFile.save());
    dispatch(
      updatePrize({
        objectId: giftToEdit.objectId,
        name,
        stock,
        pointsNeeded,
        photo: imgFile,
        available: true,
      })
    ).then(
      (response) => {
        onSuccessEditGift();
        removeImage();
        dispatch(
          setNotification({
            show: true,
            message: t("notifications.successEditGift"),
            variant: "success",
          })
        );
      },
      (error) => {
        dispatch(
          setNotification({
            show: true,
            message: error,
            variant: "error",
          })
        );
      }
    );
  };
  const isFormValid = () => {
    return name && stock && pointsNeeded && selectedFile;
  };

  const handleUploadClick = async (event) => {
    let file = null;
    if (event.target.files[0] && event.target.files[0].name.includes(".HEIC")) {
      setImageUploading(true);
      setSelectedFile(null);
      // get image as blob url
      let blobURL = URL.createObjectURL(event.target.files[0]);

      // convert "fetch" the new blob url
      let blobRes = await fetch(blobURL);

      // convert response to blob
      let blob = await blobRes.blob();

      // convert to PNG - response is blob
      let conversionResult = await heic2any({ blob, quality: 0.5 });
      file = conversionResult;
    } else if (event.target?.files) {
      setImageUploading(true);
      setSelectedFile(null);
      file = event.target.files[0];
    }

    setImageUrl(URL.createObjectURL(file));
    setSelectedFile(file);
    inputRefEdit.current.value = null;
  };
  const removeImage = () => {
    URL.revokeObjectURL(selectedFile);
    setSelectedFile(null);
    setImageUrl(null);
    inputRefEdit.current.value = null;
  };
  useEffect(() => {
    if (selectedFile) {
      setImageUploading(false);
    }
  }, [selectedFile]);

  useEffect(() => {
    if (giftToEdit) {
      setName(giftToEdit.name);
      setStock(giftToEdit.stock);
      setPointsNeeded(giftToEdit.points);
      setSelectedFile(giftToEdit.photo);
      setImageUrl(giftToEdit.photo.url);
    }
  }, [giftToEdit]);

  //   const clearForm = () => {
  //     setName("");
  //     setStock("");
  //     setPointsNeeded("");
  //   };

  const showImageBox = () => {
    return imageUrl && selectedFile;
  };
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <Box width="500px" padding="24px">
        <DialogTitle>{t("adminGiftEditorModal.editGiftTitle")}</DialogTitle>

        <Stack
          direction="column"
          display="flex"
          justifyContent="center"
          padding="0 24px"
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label={t("adminGiftEditorModal.name")}
            type="text"
            fullWidth
            variant="standard"
            value={name || ""}
            onChange={onChangeNameInput}
            required
            error={name === ""}
            helperText={name === "" ? t("errors.requiredField") : ""}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            autoFocus
            margin="dense"
            id="stock"
            label={t("adminGiftEditorModal.stock")}
            type="number"
            fullWidth
            variant="standard"
            value={stock || ""}
            onChange={onChangeStockInput}
            required
            error={stock === ""}
            helperText={stock === "" ? t("errors.requiredField") : ""}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            autoFocus
            margin="dense"
            id="pointsNeeded"
            label={t("adminGiftEditorModal.points")}
            type="number"
            fullWidth
            variant="standard"
            value={pointsNeeded || ""}
            onChange={onChangePointsNeededInput}
            required
            error={pointsNeeded === ""}
            helperText={pointsNeeded === "" ? t("errors.requiredField") : ""}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Stack marginTop="12px">
            <input
              ref={inputRefEdit}
              id="contained-button-file"
              type="file"
              multiple
              onChange={handleUploadClick}
              style={{ display: "none" }}
            />
            <label htmlFor="contained-button-file">
              <Button
                disabled={!!imageUploading || !!imageUrl}
                variant="contained"
                color="primary"
                component="span"
              >
                {t("qrCodeScanner.uploadImage")}
              </Button>
            </label>
          </Stack>
          {showImageBox() && (
            <Box
              mt={2}
              textAlign="start"
              justify="start"
              style={{ position: "relative" }}
            >
              <Stack
                display="flex"
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography>{t("adminGifts.giftImage")}</Typography>
                <img
                  src={imageUrl}
                  alt={selectedFile.name}
                  style={{
                    maxWidth: "150px",
                    position: "relative",
                  }}
                />
                <Button
                  onClick={removeImage}
                  variant="contained"
                  color="error"
                  startIcon={<RemoveIcon />}
                >
                  {t("qrCodeScanner.remove")}
                </Button>
              </Stack>
            </Box>
          )}
        </Stack>
        <DialogActions>
          <Button onClick={onClose}>{t("adminGiftEditorModal.cancel")}</Button>
          <Button
            variant="contained"
            disabled={!isFormValid() || updatePrizeLoading === "PENDING"}
            onClick={onUpdateGift}
          >
            {updatePrizeLoading === "PENDING" ? (
              <CircularProgress />
            ) : (
              t("adminGiftEditorModal.save")
            )}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
export default EditGiftModal;
